import { ReactElement, CSSProperties, memo } from 'react'
import PropTypes from 'prop-types'
import Image from 'next/image'
import { format } from 'date-fns'

import { BlogPropType } from '@/propTypes'

import Container from './style'

interface Props {
  blog: BlogInterface
  style?: CSSProperties
  className?: string
  id?: string
}

function Item({ id, blog, className, style }: Props): ReactElement {
  return (
    <Container
      id={id}
      className={className}
      style={style}
      href={blog.link}
      target="_blank"
      rel="noreferrer"
    >
      <figure>
        <Image
          src={blog.image_1.url}
          alt={blog.slug}
          quality={75}
          layout="fill"
          objectFit="cover"
        />
      </figure>
      <h1>{blog.title}</h1>
      <p>{format(new Date(blog.published_at), 'dd/MM/yyyyy')}</p>
    </Container>
  )
}

Item.propTypes = {
  blog: BlogPropType.isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
  id: PropTypes.string,
}

Item.defaultProps = {
  className: '',
}

export default memo(Item)
